import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ADMINPRODUCTFEATURES } from '../../../../constants/applicationConstants';
import {
  DataTableHoc,
  Loader,
  ErrorFallback,
  deleteFilter,
  applyFilter,
  saveFilters,
} from 'smart-react';
import { GridColumnsList } from '../Components/Filter/FilterElements';
import DataColumns from '../Components/DataColumns/DataColumns';
import {
  ROW_LAYOUTS,
  PAGE_SIZE,
} from '../../../../constants/applicationConstants';
const BaseProductFeatureDataTable = React.lazy(
  () => import('../Components/DataTable/DataTable'),
);
const ProductFeatureDataTable = DataTableHoc(BaseProductFeatureDataTable);

/**
 * Product Feature main screen
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Product Feature  component.
 */
const ProductFeature = ({ product }) => {
  const [userData, setUserData] = React.useState([]);
  const dataColumnsArray = DataColumns({});
  // used to check API is ready to call
  const [isReady, setIsReady] = React.useState(false);
  

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      <div className='container mx-auto k-px-4'>
        <React.Suspense fallback={<Loader />}>
          <ProductFeatureDataTable
            product={product}
            deleteFilter={deleteFilter}
            applyFilter={applyFilter}
            saveFilters={saveFilters}
            moduleName={ADMINPRODUCTFEATURES}
            dataColumns={dataColumnsArray}
            gridColumnsList={GridColumnsList}
            dataTableName={ADMINPRODUCTFEATURES}
            setIsReady={setIsReady}
            isReady={isReady}
            rowLayoutConfigName={`${ADMINPRODUCTFEATURES}.DataGrid.RowLayout`}
            pageLengthConfigName={`${ADMINPRODUCTFEATURES}.DataGrid.ItemsPerPage`}
            dataSet={userData}
            setDataSet={setUserData}
            initialSort={{
              field: 'id',
              dir: 'desc',
            }}
            isCardonMobileView={false}
            total={process.env.DefaultLimit}
            defaultRowLayout={process.env.RowLayout}
            rowLayouts={ROW_LAYOUTS}
            pageSizes={PAGE_SIZE}
          />
        </React.Suspense>
      </div>
    </ErrorBoundary>
  );
};
export default ProductFeature;
